import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetVehicleListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    selectedVehicleOwners: CustomMultiSelectModel[]
    selectedVehicleStatuses: CustomMultiSelectModel[]
    selectedIsCustomActives: CustomMultiSelectModel[]
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    selectedVehicleTypes: CustomMultiSelectModel[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetVehicleListPagingAndFilterRequest: GetVehicleListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    selectedVehicleOwners: [],
    selectedVehicleStatuses: [],
    selectedIsCustomActives: [],
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    selectedVehicleTypes: [],
    columnFilters: []
}